/* eslint-disable @typescript-eslint/no-explicit-any */
import _ from 'lodash';

import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { TicketTypePackage } = protos;

export function fetchAll(): ApiAction {
  return {
    TockApi: {
      getListProto: '/ticket/type/package',
      type: AppConstants.PACKAGE_FETCH_ALL,
    },
  };
}

export function add(ticketTypePackage: any): ApiAction {
  const request = TicketTypePackage.fromObject(ticketTypePackage);
  return {
    TockApi: {
      postProto: '/ticket/type/package',
      request,
      toast: 'Experience package created',
      type: AppConstants.PACKAGE_ADD,
    },
  };
}

export function update(ticketTypePackage: any): ApiAction {
  const request = TicketTypePackage.fromObject(ticketTypePackage);
  return {
    TockApi: {
      putProto: '/ticket/type/package',
      request,
      toast: 'Experience package updated',
      type: AppConstants.PACKAGE_UPDATE,
    },
  };
}

export function updateAll(packages: any): ApiAction {
  const requests = _.map(packages as any[], (ticketTypePackage) => ({
    method: 'PUT',
    path: '/ticket/type/package',
    payload: TicketTypePackage.fromObject(ticketTypePackage),
    requestType: TicketTypePackage,
  }));

  return {
    TockApi: {
      batchProto: requests,
      type: AppConstants.NULL,
    },
  };
}

export function archive(ticketTypePackage: any): ApiAction {
  const request = TicketTypePackage.fromObject(ticketTypePackage);
  request.isArchived = true;

  return {
    TockApi: {
      putProto: '/ticket/type/package',
      request,
      toast: 'Experience package archived',
      type: AppConstants.PACKAGE_UPDATE,
    },
  };
}

export function unarchive(ticketTypePackage: any): ApiAction {
  const request = TicketTypePackage.fromObject(ticketTypePackage);
  request.isArchived = false;

  return {
    TockApi: {
      putProto: '/ticket/type/package',
      request,
      toast: 'Experience package unarchived',
      type: AppConstants.PACKAGE_UPDATE,
    },
  };
}
